// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__GJgK1","table":"style__table__SK47K","center":"style__center__o1rlQ","group":"style__group__UMU6-","title":"style__title__73uuA"};